import { createSearchParams, useNavigate, useParams } from 'react-router-dom'

import Button from '../common/Button'
import InlineCheckbox from '../common/InlineCheckbox'
import InputText from '../common/InputText'
import TextArea from '../common/TextArea'
import { useContext, useEffect, useState } from 'react'
import { NavContext } from '../../context/global_context'
import { getLocalStorageData } from '../../utils/LocalStorageAccess'
import { getRequest, postRequest, putRequest } from '../../services/base'
import SelectInput from '../common/SelectInput'

const VehicleForm = (props) => {
  const { vehicle } = useParams()
  const [value, dispatch] = useContext(NavContext)
  const [optionCodes, setOptionCodes] = useState([])
  const navigate = useNavigate()
  const vehicle_redirect_url = getLocalStorageData('vehicle')?.search
    ? `/vehicles/?${createSearchParams(getLocalStorageData('vehicle'))}`
    : `/vehicles`

  useEffect(() => {
    dispatch({
      type: 'header',
      data: {
        header: vehicle ? vehicle : 'New',
        sub_header: vehicle ? 'Edit Vehicle' : 'Create New Vehicle',
        id: '',
        show_back_btn: true,
        dtc_details: {},
        vehicle: vehicle,
        back_btn_url: vehicle_redirect_url,
        full_width_container: false,
      },
    })
    getsetOptionCodes()
  }, [])

  const saveVehicle = async (e) => {
    e.preventDefault()
    const form = e.target
    const formData = new FormData(form)
    formData.delete('vin_dependent_tags')
    if (typeof props.vehicleDetails?.vin_dependent_tags === 'object') {
      formData.append(
        'vin_dependent_tags',
        JSON.stringify(props.vehicleDetails?.vin_dependent_tags)
      )
    } else {
      formData.append(
        'vin_dependent_tags',
        JSON.stringify(props.vehicleDetails?.vin_dependent_tags.split(','))
      )
    }

    if (vehicle) {
      let res = await putRequest(
        `/api/vehicles/update_vehicle_details/${vehicle}/`,
        formData
      )
      navigate(vehicle_redirect_url)
    } else {
      let res = await postRequest(
        `/api/vehicles/save_vehicle_details/`,
        formData
      )
      navigate(vehicle_redirect_url)
    }
  }

  const setDetailsInState = (name, value) => {
    props.setVehicleDetails({ ...props.vehicleDetails, [`${name}`]: value })
  }

  const getsetOptionCodes = async () => {
    if (vehicle) {
      let res = await getRequest(
        `/api/option_codes/options/?vehicle=${vehicle}`
      )
      setOptionCodes(res)
    } else {
      setOptionCodes([])
    }
  }

  return (
    <>
      <div className="w-full p-2">
        <form
          id="vehicle-form-details"
          onSubmit={(e) => {
            saveVehicle(e)
          }}
        >
          <div className="w-full">
            <div className="p-2 font-bold br-bottom-top-1px">
              ** Vehicle Basic Details **
            </div>

            <div className="flex">
              <div className="w-1/3">
                <InputText
                  type="text"
                  onChange={(value) => {
                    setDetailsInState('make', value)
                  }}
                  label="Make"
                  name="make"
                  value={props.vehicleDetails?.make}
                />
              </div>
              <div className="w-1/3">
                <InputText
                  type="text"
                  onChange={(value) => {
                    setDetailsInState('model', value)
                  }}
                  label="Model"
                  name="model"
                  value={props.vehicleDetails?.model}
                />
              </div>
              <div className="w-1/3">
                <InputText
                  type="number"
                  onChange={(value) => {
                    setDetailsInState('year', value)
                  }}
                  label="Manufacturing Year"
                  name="year"
                  value={props.vehicleDetails?.year}
                />
              </div>
              <div className="w-1/3">
                <InputText
                  type="text"
                  onChange={(value) => {
                    setDetailsInState('phase', value)
                  }}
                  label="Phase"
                  name="phase"
                  value={props.vehicleDetails?.phase}
                />
              </div>
            </div>
            <div className="flex">
              <div className="w-1/4">
                <InputText
                  type="text"
                  onChange={(value) => {
                    setDetailsInState('make_description', value)
                  }}
                  label="Make Description"
                  name="make_description"
                  value={props.vehicleDetails?.make_description}
                  isRequired={false}
                />
              </div>
              <div className="w-1/4">
                <InputText
                  type="text"
                  onChange={(value) => {
                    setDetailsInState('model_description', value)
                  }}
                  label="Model Description"
                  name="model_description"
                  value={props.vehicleDetails?.model_description}
                  isRequired={false}
                />
              </div>
              <div className="w-1/4">
                <SelectInput
                  value={props.vehicleDetails?.default_option_code_data}
                  onChange={(value) => {
                    setDetailsInState('default_option_code', value)
                    setDetailsInState('default_option_code_data', value)
                  }}
                  label="Default Options Code"
                  name="default_option_code"
                  isRequired={false}
                  options={optionCodes}
                />
              </div>
            </div>
          </div>
          <div className="w-full mt-3">
            <div className="p-2 font-bold br-bottom-top-1px">
              ** Vehicle Advance Details **
            </div>

            <div className="flex">
              <div className="w-1/3">
                <InputText
                  type="text"
                  onChange={(value) => {
                    setDetailsInState('time_zone', value)
                  }}
                  label="Time Zone"
                  name="time_zone"
                  value={props.vehicleDetails?.time_zone}
                />
              </div>
              <div className="w-1/3">
                <InputText
                  type="text"
                  onChange={(value) => {
                    setDetailsInState('company', value)
                  }}
                  label="Company Details"
                  name="company"
                  value={props.vehicleDetails?.company}
                />
              </div>

              <div className="w-1/3">
                <InputText
                  type="number"
                  onChange={(value) => {
                    setDetailsInState('make_model_id', value)
                  }}
                  label="Make Model Id"
                  name="make_model_id"
                  value={props.vehicleDetails?.make_model_id}
                />
              </div>

              <div className="w-1/3">
                <TextArea
                  onChange={(value) => {
                    console.log(value)
                    setDetailsInState('vin_dependent_tags', value)
                  }}
                  label="Vin Dependent Tags"
                  name="vin_dependent_tags"
                  value={props.vehicleDetails?.vin_dependent_tags}
                />
              </div>
            </div>
            <div className="w-full mt-3">
              <div className="p-2 font-bold br-bottom-top-1px">
                ** Vehicle SVG Details **
              </div>
              <div className="flex">
                <div className="w-1/3">
                  <InlineCheckbox
                    type="checkbox"
                    onChange={(value) => {
                      setDetailsInState('svg_enabled', value)
                    }}
                    label="SVG Status"
                    name="svg_enabled"
                    value={props.vehicleDetails?.svg_enabled}
                  />
                </div>
                <div className="w-1/3">
                  <InputText
                    type="text"
                    onChange={(value) => {
                      setDetailsInState('svg_stroke', value)
                    }}
                    label="SVG Stroke"
                    name="svg_stroke"
                    value={props.vehicleDetails?.svg_stroke}
                  />
                </div>
                <div className="w-1/3">
                  <InputText
                    type="text"
                    onChange={(value) => {
                      setDetailsInState('svg_fill', value)
                    }}
                    label="SVG Fill"
                    name="svg_fill"
                    value={props.vehicleDetails?.svg_fill}
                  />
                </div>
                <div className="w-1/3">
                  <InputText
                    type="text"
                    onChange={(value) => {
                      setDetailsInState('svg_resolution', value)
                    }}
                    label="SVG Resolution"
                    name="svg_resolution"
                    value={props.vehicleDetails?.svg_resolution}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="flex justify-end">
            <div className="w-1/4 p-2">
              <Button
                type="submit"
                className={`cursor-pointer btn my-4 w-full justify-end`}
                onClick={(e) => console.log(e)}
                value={'text'}
                text="Save Vehicle Details"
              />
            </div>
          </div>
        </form>
      </div>
    </>
  )
}

export default VehicleForm
